








































import {
    Component,
    Prop,
    Vue,
    Inject,
    Provide,
    Watch
} from "vue-property-decorator";
@Component({
})
export default class BackToTop extends Vue{
    show =false
    mounted(){
        window.addEventListener('scroll', this.handleScroll)
    }
    
    destroyed(){
        window.removeEventListener('scroll',this.handleScroll)
    }
    handleScroll(){
        if (document.documentElement.scrollTop > 150) {
            this.show = true
        } else {
            this.show = false
        }
    }
    do_back_to_top(){
        document.documentElement.scrollTop = 0
    }
}
